import { Controller } from "@hotwired/stimulus"

// Makes a table row clickable — navigates to the URL in data-href
export default class extends Controller {
  click(event) {
    // Don't navigate if they clicked a link or button inside the row
    if (event.target.closest("a, button")) return
    const url = this.element.dataset.href
    if (url) window.open(url, "_blank")
  }
}
